import { Role } from '@/types';

const rank: Record<Role, number> = {
  [Role.DEMO]: 0,
  [Role.MEMBER]: 1,
  [Role.ADMIN]: 2,
  [Role.OWNER]: 3,
};

const actions = {
  'controllers.configure': Role.MEMBER,
  'controllers.delete': Role.MEMBER,
  'controllers.move': Role.ADMIN,
  'members.invite': Role.ADMIN,
  'members.remove': Role.ADMIN,
  'members.changeRole': Role.OWNER,
  'members.viewTotp': Role.ADMIN,
  'organization.manage': Role.ADMIN,
  'organization.rename': Role.ADMIN,
  'organization.requireTotp': Role.ADMIN,
  'organization.delete': Role.OWNER,
} as const;

export type Action = keyof typeof actions;

export const can = (role: Role, action: Action) =>
  rank[role] >= rank[actions[action]];

export const canRemoveMember = (actorRole: Role, targetRole: Role) =>
  can(actorRole, 'members.remove') && rank[actorRole] > rank[targetRole];

export const canChangeMemberRole = (actorRole: Role, targetRole: Role) =>
  can(actorRole, 'members.changeRole') && targetRole !== Role.OWNER;

export const displayedActions = [
  { action: 'controllers.configure', labelKey: 'roleActions.controllersConfigure' },
  { action: 'controllers.move', labelKey: 'roleActions.controllersMove' },
  { action: 'members.invite', labelKey: 'roleActions.membersInvite' },
  { action: 'organization.rename', labelKey: 'roleActions.organizationSettings' },
  { action: 'members.changeRole', labelKey: 'roleActions.adminsAssign' },
  { action: 'organization.delete', labelKey: 'roleActions.organizationDelete' },
] as const satisfies readonly { action: Action; labelKey: string }[];
